import noUiSlider from 'nouislider';
import tippy from 'tippy.js';
import i18next from 'i18next';
import { modals } from  '../../blocks-ui/modals/modals';

(function(){
  const slider = document.querySelector('#tariff-slider');
  if (!slider) return;

  function getValuesArr({ min, step }) {
    const length = 200;
    return Array.from({ length }, (v, i) => {
      return min + i * step;
    });
  }

  function formatNumber(number) {
    if (typeof +number !== 'number' || !intl) return number;
    return new Intl.NumberFormat('ru-RU').format(number);
  }

  const subscribersHtml = document.querySelector('.js-tariff-subscribers');
  const paymentHtml = document.querySelector('.js-tariff-payment');
  const subscribersArr = getValuesArr({ min: 1000, step: 1000 });
  const paymentsArr = getValuesArr({ min: 4, step: 4 });
  const intl = !!window.Intl;

  const config = {
    animate: true,
    animationDuration: 300,
    behaviour: 'tap-drag',
    connect: [true, false],
    start: 9,
    step: 1,
    format: {
      to(value) {
        return value;
      },
      from(value) {
        return Number(value.replace(',-', ''));
     }
    },
    range: {
      'min': 0,
      'max': 199
    }
  }

  noUiSlider.create(slider, config);

  const sliderHandle = document.querySelector('.noUi-handle');
  const tooltipInstance = tippy(sliderHandle, {
    animation: 'fade',
    boundary: 'window',
    content: function(reference) {
      const id = 'data-tariff-more';
      const container = document.createElement('div');
      const linkedTemplate = document.getElementById(id);
      const node = document.importNode(linkedTemplate.content, true);
      const innerNode = node.childNodes[0];
      const moreContainer = document.createElement('p');
      const more = document.createElement('strong');
      more.innerText = i18next.t('NEED_MORE');
      moreContainer.appendChild(more);
      innerNode.appendChild(moreContainer);
      const contact = document.createElement('p');
      contact.innerHTML = i18next.t('CONTACT_FOR_CUSTOM_PLAN');
      innerNode.appendChild(contact);
      container.appendChild(node);
      return container
    },
    flip: false,
    interactive: true,
    maxWidth: 156,
    placement: 'top',
    theme: 'grv',
    trigger: 'manual',
  });
  let isOpen = false;

  slider.noUiSlider.on('update', () => {
    const step = Math.round(slider.noUiSlider.get());
    subscribersHtml.innerText = formatNumber(subscribersArr[step]);
    paymentHtml.innerText = paymentsArr[step];
    const maxRange = config.range.max;

    if (!tooltipInstance) {
      return;
    }

    if (step === maxRange) {
      isOpen = true;
      tooltipInstance.show();
      const showSupportHandler = document.querySelector('.js-show-support-modal');
      const closeTooltipHandler = document.querySelector('.js-close-tooltip-tariff-more');
      showSupportHandler.addEventListener('click', () => modals.open('support-modal'));
      closeTooltipHandler.addEventListener('click', () => tooltipInstance.hide());
    }

    if (step !== maxRange && isOpen) {
      isOpen = false;
      tooltipInstance.hide();
    }
  });
})();

{
  const  tooltips = document.querySelectorAll('[data-tariff-tooltip]');
  tippy(tooltips, {
    animation: 'fade',
    boundary: 'window',
    content: function(reference) {
      const id = reference.getAttribute('data-template');
      const container = document.createElement('div');
      const linkedTemplate = document.getElementById(id);
      const node = document.importNode(linkedTemplate.content, true);
      container.appendChild(node);
      const translates = [...container.querySelectorAll('[data-i18n]')];
      translates.forEach((block) => {
        const key = block.getAttribute('data-i18n');
        block.innerHTML = i18next.t(key);
      });
      return container
    },
    flip: false,
    interactive: true,
    maxWidth: 156,
    placement: 'top',
    theme: 'grv',
    trigger: 'mouseenter'
  });
}